import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=1f4cc25c&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=1f4cc25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4cc25c",
  null
  
)

export default component.exports